import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Table, Spinner} from 'reactstrap';
import {ArtistInput} from "./ArtistInput"

import ReactTooltip from 'react-tooltip';


export class Home extends Component {
  state = { 
    artists: [],
    artistName: "",
    artistId: "",
    tracks: [],
    numberOfTracks: 32,
    newNumberOfTracks: 0,
    mainDivisors: [],
    favoriteTrack: "",
    highlight: false
  };

  render() {
    return (
      <div className="backgroundDiv">
        <div className="mainDiv"> 
          <div className="mainTitle">
            <p className="mainTitleP">Music Madness Bracket Generator</p>
            <p className="subTitleP">Generate interactive tournament brackets for your favorite artists 
              based on their Spotify's  top tracks </p>
          </div>

          <div className="newBracketButtontDiv" id="newBracketButtontDiv"></div> 
          <p id="subTableLabel"> </p>
          <div id="resultDivParent" className="resultDivParent"></div>

          <p id="tableLabel">Search Artists</p>
          <div id="artistInput">
            <ArtistInput parentThis={this}/>
          </div>
          <div id="artistsTableParent"><div id="artistsTable"></div></div>

          <div id="tracksBracket" className="tracksBracket"></div>
          <div id="spinner"></div>

          <div className="creatorDiv">
            <p className="text-muted">
              Created by <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/espedito-junior-931527128/">Espedito Junior</a>
            </p>
          </div>
        </div>
      </div>
    );
  }

  searchArtists = e => {
    this.setState({artistName: e.target.value}, this.searchArtistsAPI);
  }

  searchArtistsAPI = e => {

    if(this.state.artistName !== "" && this.state.artistName !== "#" && this.state.artistName !== "&" 
      && this.state.artistName !== "*" && this.state.artistName !== "+" && this.state.artistName !== ";" ) {
      fetch('/Artists?artistName='+this.state.artistName).then(response => {
        response.json().then( json => {
  
          if(json["artists"]) {
            this.setState({ artists: json["artists"]["items"]});

            console.log(this.state.artists);

            const artistsTable =  (
              <table className='table' aria-labelledby="tabelLabel">
                <tbody>
                  {this.state.artists.map(artist => {
                    if(artist.images.length > 0 ) {
                        return (
                        <tr key={artist.id} onClick={() => { this.selectArtist(artist.id,artist.name) }} className="clickMe">
                          <td className="artistTd">
                            <div className="artistTableMain rounded">
                              <div className="artistTableImage"><img src={artist.images[2] ? artist.images[2].url : artist.images[0].url} alt={artist.name} /></div>
                              <div className="artistTableText"><span>{artist.name}</span></div>
                            </div>
                          </td>
                        </tr>
                      )
                    } else {
                      return ""
                    }
                  })}
                </tbody>
              </table>
            );

            if(document.getElementById('artistsTable')) {
              ReactDOM.render(artistsTable, document.getElementById('artistsTable'));
            }

          }
  
        });
      });
    } 
  }

  selectArtist = (id,name) => {
    this.setState({artistId: id}, this.getTracks);
    this.setState({artistName: name}, this.searchArtistsAPI);
  }

  getTracks = e => {
    console.log("Get tracks of : " + this.state.artistId);
    console.log("Get number : " + this.state.numberOfTracks);

    const spinner = (
      <Spinner animation="border" role="status">
        <span className="sr-only">Loading...</span>
      </Spinner>
    );

    ReactDOM.render(null, document.getElementById('artistsTableParent'));
    ReactDOM.render(spinner, document.getElementById('spinner'));
    ReactDOM.render(null, document.getElementById('artistInput'));
    ReactDOM.render("Loading " + this.state.artistName+"'s top "+this.state.numberOfTracks+" tracks from Spotify...", document.getElementById('tableLabel'));

    fetch('/Tracks?artistId='+this.state.artistId+'&numberOfTracks='+this.state.numberOfTracks).then(response => {
      response.json().then( json => {
        
        console.log(json);


        if(parseInt(json.length) === parseInt(this.state.numberOfTracks)) {
          
          this.generateBracket(json);

          console.log("exato");

        } else {

          console.log("faltou");

          this.setState({ newNumberOfTracks: this.state.numberOfTracks });

          while(this.state.newNumberOfTracks >= json.length) {
            this.setState({ newNumberOfTracks: this.state.newNumberOfTracks/2 });
          }

          var message = "";

          if(this.state.newNumberOfTracks >= 8) {
            message = "Not enough tracks for a "+this.state.numberOfTracks+
              " tracks bracket. The largest bracket possible has " + this.state.newNumberOfTracks + " tracks";

            this.setState({ numberOfTracks: this.state.newNumberOfTracks });
            this.generateBracket(json.slice(0,this.state.newNumberOfTracks));
            ReactDOM.render(<div id="artistsTable"></div>, document.getElementById('artistsTableParent'));

          } else {
            message = "This artist doesn’t have enought tracks for our smallest bracket possible. Please select another artist";
            ReactDOM.render(<ArtistInput parentThis={this} />, document.getElementById('artistInput'));
            ReactDOM.render(<div id="artistsTable"></div>, document.getElementById('artistsTableParent'));
          } 

          ReactDOM.render(message, document.getElementById('subTableLabel'));  
          ReactDOM.render(null, document.getElementById('spinner'));  

        }
        

      });
    });

  }

  generateBracket(json) {

    var tracks = this.shuffleArray(json);
        
    var tr_id = 1;
    var id_group = 1;
 
    var lastDivider = 4;

    var halfOfTracks = this.state.numberOfTracks/2;

    var mainDivisors = [];
    var done = [];

    while(halfOfTracks >= 4) {

      mainDivisors.push(halfOfTracks);

      halfOfTracks = halfOfTracks/2;
    }

    this.setState({ mainDivisors: mainDivisors});

    const tracksBracket =  (
      <div className="tracksBracketTableParent">
        <ReactTooltip />
        <Table className="tracksBracketTable">
          <tbody>
            {tracks.map((value, index) => {
              if(index % 2 === 0 &&  index+1 <= tracks.length-1) {
                return (
                  <tr id={"tr_" + (tr_id)}>
                    <td className={"td_odd_"+tr_id} data-tip={value.name}
                      onClick={(e) => { this.pickTrack(1,index+1,e,lastDivider) }}  
                    >
                      <input 
                      className={"clickable odd_"+tr_id}
                      data-group={"odd_"+id_group} data-value={value.name} 
                      data-image={value.album.images[0].url}
                      data-album={value.album.name}
                      id={"odd_1_"+tr_id}  disabled value={value.name}/>
                    </td>
                      {(() => {
                        const returnJsx = [];
                        
                        this.state.mainDivisors.forEach((divisor) => {
                        
                          if(!done.includes(index) && (index % divisor === 0)) {

                            var counter =  divisor;
                            var divider = counter*2;
                            var log = 0;

                            if(index === 0) {
                              counter =  divisor*2;
                              divider = null;
                            }

                            while(counter >= lastDivider)  {

                              log = (Math.log(counter) / Math.log(2));

                              returnJsx.unshift(
                                <td className={"td_odd_"+log+"_"+((index/counter)+1)}
                                rowSpan={counter/2} 
                                onClick={(e) => { this.pickTrack(e.target.dataset.column,index+1,e,e.target.dataset.divider) }}
                                data-tip="" 
                                > 
                                    <input id={"odd_"+log+"_"+((index/counter)+1)} 
                                    data-column={log}
                                    data-divider={divider} disabled/>
                                </td>
                              );

                              returnJsx.push(
                                <td className={"td_even_"+log+"_"+((index/counter)+1)}
                                rowSpan={counter/2} 
                                onClick={(e) => { this.pickTrack(e.target.dataset.column,index+2,e,e.target.dataset.divider) }}
                                data-tip="" 
                                >
                                    <input id={"even_"+log+"_"+((index/counter)+1)} 
                                    data-column={log}
                                    data-divider={divider} disabled/>
                                </td>
                              );
                              
                              divider = counter;
                              counter = counter/2;
                            }

                            done.push(index);
                          }

                        });

                        return returnJsx;
                        
                      })()}
                    <td onClick={(e) => { this.pickTrack(1,(index+2),e,lastDivider)}}
                      className={"td_even_"+tr_id} 
                      data-tip={tracks[index+1].name}
                    >
                      <input  className={"clickable even_"+tr_id}
                      data-group={"even_"+id_group} data-value={tracks[index+1].name}
                      data-image={tracks[index+1].album.images[0].url}
                      data-album={tracks[index+1].album.name}
                      id={"input_even_1_"+tr_id}   disabled value={tracks[index+1].name} /> 
                    </td>
                  </tr>
                )
              } else {
                if(tr_id % 2 === 0){
                  id_group++;
                }
                tr_id++;
                return ""
              }
            })}
          </tbody>
        </Table>

      </div>
    );

    const newBracketButton = (
      <button className="btn btn-outline-secondary customButton" onClick={() => { window.location.reload() }}>
        Generate a new bracket for another artist
      </button>
    );
    
    ReactDOM.render(newBracketButton, document.getElementById('newBracketButtontDiv'));
    ReactDOM.render(null, document.getElementById('spinner'));
    ReactDOM.render(null, document.getElementById('tracksBracket'));        
    ReactDOM.render(tracksBracket, document.getElementById('tracksBracket'));
    
    setTimeout(() => {
      document.getElementById('tracksBracket').classList.add("tracksBracketVisible");
    }, 500);

    ReactDOM.render("Pick your favorite "+this.state.artistName+"'s tracks", document.getElementById('tableLabel'));
  }

  shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  }

  pickTrack (columnPosition, position, element, divider){

    console.log(element.target.id);
    columnPosition = parseInt(columnPosition);

    var even_odd = "";

    if(position % 2 === 0) {
      even_odd = "even";
    } else {
      even_odd = "odd";
    }

    var neighbour;

    if(element.target.dataset.value && element.target.classList.contains("clickable") && divider) {
      
      var advanceTrack = false;
      var ending = false;

      if(columnPosition === 1) {
        var groupMembers = document.querySelectorAll("[data-group='"+element.target.dataset.group+"']");
        
        groupMembers.forEach(member =>  {
            member.classList.remove("clickable");
            member.classList.add("notClicked");
          }
        );
        advanceTrack = true;
        element.target.classList.add("clicked");
      } else {

        var rowPosition = (((position-1)/(divider/2))+1);
        var neighbourId;
        if(rowPosition % 2 === 0 || (even_odd === "even" && Math.floor(rowPosition) % 2 === 0)) {
          neighbourId = even_odd + "_" + columnPosition + "_" + (Math.ceil(position/divider*2) - 1);
        } else {
          neighbourId = even_odd + "_" + columnPosition + "_" + (Math.ceil(position/divider*2) + 1);      
        }

        neighbour = document.getElementById(neighbourId);
 
        if(neighbour.dataset.value) {
          advanceTrack = true;
        } else {
          neighbour.classList.add("highlight");
          setTimeout(() => {
            neighbour.classList.remove("highlight");
          }, 500);
        }
      }

      if(advanceTrack) {
        var nexTrackId = even_odd + "_" + (columnPosition+1) + "_" + (Math.ceil(position/divider));  
        var nextTrackPosition = document.getElementById(nexTrackId);

        console.log(nexTrackId);

        nextTrackPosition.dataset.value = element.target.dataset.value;
        nextTrackPosition.value = element.target.dataset.value;
        nextTrackPosition.classList.add("clickable");
        nextTrackPosition.setAttribute("data-image", element.target.dataset.image);
        nextTrackPosition.setAttribute("data-album", element.target.dataset.album);

        var nextTrackPositionParent = nextTrackPosition.parentNode;
        nextTrackPositionParent.setAttribute("data-tip", element.target.dataset.value);

      }
  
    } else if(element.target.dataset.value && element.target.classList.contains("clickable") && !divider) {

      if(even_odd === "even") {
        neighbour = document.getElementById("odd_"+columnPosition+"_1"); 
      } else {
        neighbour = document.getElementById("even_"+columnPosition+"_1"); 
      }

      if(neighbour.dataset.value) {
        ending = true;

        var favoriteTrack= {"name": element.target.dataset.value, "image": element.target.dataset.image};

        this.setState({favoriteTrack: favoriteTrack}, function (){
          this.generateResultDiv();
        });
        
      } else {
        neighbour.classList.add("highlight");
        setTimeout(() => {
          neighbour.classList.remove("highlight");
        }, 500);
      }

    } else {
      console.log("vazio");
    }

    if((advanceTrack && columnPosition !== 1) || ending) {
      neighbour.classList.remove("clickable");
      neighbour.classList.add("notClicked");
      element.target.classList.remove("clickable");
      
      if(!ending) {
        element.target.classList.add("clicked");
      } else {
        element.target.classList.add("champion");
      }
    }
  }

  generateResultDiv() {

    const resultDiv =  ( 
      <div className="resultDivTrack">
        <h4 className="favoriteTrackNameLabel">Your favorite {this.state.artistName} track:</h4>
        <h3 className="favoriteTrackName">{this.state.favoriteTrack.name}</h3>
        <img className="imgResult" alt={this.state.favoriteTrack.name} src={this.state.favoriteTrack.image}></img>
      </div>
    );
    
    
    ReactDOM.render(null, document.getElementById('subTableLabel')); 
    ReactDOM.render(null, document.getElementById('tableLabel')); 
    ReactDOM.render(null, document.getElementById('resultDivParent')); 
    ReactDOM.render(resultDiv, document.getElementById('resultDivParent'));

    setTimeout(() => {
      document.getElementById('resultDivParent').classList.add("resultDivParentVisible");
      window.location.href = "#root";
    }, 500);


  }

}